import React from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import ConfirmModal from '../../incase-domain/components/modals/confirmModal/ConfirmModal';

interface ExitLobbyModalProps {
    isOpen: boolean;
    setOpen: (isOpen: boolean) => void;
}

function ExitLobbyModal({isOpen, setOpen}: ExitLobbyModalProps): JSX.Element {
    const {t} = useTranslation();
    const navigate = useNavigate();

    const handleLogout = (): void => {
        navigate('/');
    };

    return (
        <ConfirmModal
            message={t('lobby.exitHeader')}
            icon="solar:logout-3-bold"
            isOpen={isOpen}
            onConfirm={() => handleLogout()}
            showCancel
            onCancel={() => setOpen(false)}
        />
    );
}

export default ExitLobbyModal;
